import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Input, Select, Button } from 'components';
import { TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { BankAccountService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class BankAccounts extends React.Component<Props> {

	state = {
		payment_methods: [],
		selected: null,
		banks: [],
		document_types: [],
		bank_accounts: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cuentas Bancarias',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await BankAccountService.admin.get();
		this.setState({
			payment_methods: res.payment_methods.filter((i: any) => [
				Constants.PAYMENT_METHODS.ZELLE,
				Constants.PAYMENT_METHODS.TRANSFER,
				Constants.PAYMENT_METHODS.CASH,
				Constants.PAYMENT_METHODS.MOVIL
			].indexOf(i.id) != -1 ),
			banks: res.banks,
			document_types: res.document_types,
			selected: Constants.PAYMENT_METHODS.MOVIL,
			bank_accounts: res.bank_accounts
		});
	}

	submit = async () => {
		const item = this.state.bank_accounts.find((i: any) => !i.bank_id || !i.number);

		if (item) {
			Globals.showError(`Debe ingresar todos los bancos y números de cuenta de las cuentas verdes`);
			return;
		}

		await BankAccountService.admin.save({
			payment_methods: JSON.stringify(this.state.payment_methods),
			bank_accounts: JSON.stringify(this.state.bank_accounts)
		});
		Globals.showSuccess("Se han guardado los cambios");
	}

	change = (e: any, type: number) => {
		let payment_methods: any = [...this.state.payment_methods];
		const index = payment_methods.findIndex((i: any) => i.id == type);
		payment_methods[index][e.target.name] = e.target.value;
		this.setState({
			payment_methods
		});
	}

	changeBankAccount = (e: any, index: number) => {
		let bank_accounts: any = [...this.state.bank_accounts];
		bank_accounts[index][e.target.name] = e.target.value;
		this.setState({
			bank_accounts
		});
	}
	
	render() {
		const payment_movil: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.MOVIL);
		const zelle: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.ZELLE);
		const transfer: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.TRANSFER);

		return (
			<div id="bank-accounts">
				<BackComponent />

				<div className="row">
					<div className="col-md-4">
						{
							this.state.payment_methods.map((item: any) => {
								return (
									<div className={ `item-payment-method ${ this.state.selected == item.id ? 'active' : '' }` } onClick={ () => {
										this.setState({
											selected: item.id
										});
									} }>
										<img src={ Constants.BASE_PUBLIC + item.photo } />
										<p>{ item.name }</p>
									</div>
								)
							})
						}
					</div>
					<div className="col-md-8">
						<div className="container-form">
							<h3>Datos</h3>
							<div className="container-data">
								{
									payment_movil !== null && this.state.selected == Constants.PAYMENT_METHODS.MOVIL && (
										<React.Fragment>
											<Select
												label="Banco"
												name="bank_id"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.MOVIL) }
												value={ payment_movil?.bank_id }
												options={ this.state.banks.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												type="number"
												color="white"
												value={ payment_movil?.phone }
												name="phone" 
												label="Teléfono"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.MOVIL) } />
											<div className="container-document">
												<Select
													label="RIF / Cédula"
													name="document_type_id"
													onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.MOVIL) }
													value={ payment_movil?.document_type_id }
													options={ this.state.document_types.map((i: any) => {
														return {
															value: i.id,
															label: i.name
														}
													}) } />
												<Input
													label="-"
													type="number"
													color="white"
													value={ payment_movil?.document }
													name="document" 
													placeholder="Documento"
													onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.MOVIL) } />
											</div>
										</React.Fragment>
									)
								}

								{
									this.state.selected == Constants.PAYMENT_METHODS.CASH && (
										<React.Fragment>
											<div className="text-right">
												<Button className="btn-add-account" onClick={ () => {
													let bank_accounts: any = [...this.state.bank_accounts];
													bank_accounts.push({
														bank_id: '',
														number: ''
													});
													this.setState({
														bank_accounts
													});
												} }>
													<img src={ AddWhiteIcon } /> Agregar
												</Button>
											</div>
											{
												this.state.bank_accounts.map((item: any, index: number) => {
													return (
														<div className="item-bank-account">
															<div>
																<Select
																	label="Banco"
																	name="bank_id"
																	onChange={ (e: any) => this.changeBankAccount(e,index) }
																	value={ item?.bank_id }
																	options={ this.state.banks.map((i: any) => {
																		return {
																			value: i.id,
																			label: i.name
																		}
																	}) } />
																<Input
																	label="Número de cuenta"
																	type="number"
																	color="white"
																	value={ item?.number }
																	name="number" 
																	placeholder="Número de cuenta"
																	onChange={ (e: any) => this.changeBankAccount(e,index) } />
															</div>
															<Button className="btn-delete-account" onClick={ () => {
																let bank_accounts: any = [...this.state.bank_accounts];
																bank_accounts.splice(index,1);
																this.setState({
																	bank_accounts
																});
															} }>
																<img src={ TrashIcon } />
															</Button>
														</div>
													)
												})
											}
											{
												this.state.bank_accounts.length == 0 && (
													<p className="no-items">No se han agregado cuentas bancarias</p>
												)
											}
										</React.Fragment>
									)
								}

								{
									transfer !== null && this.state.selected == Constants.PAYMENT_METHODS.TRANSFER && (
										<React.Fragment>
											<Select
												label="Banco"
												name="bank_id"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.TRANSFER) }
												value={ transfer?.bank_id }
												options={ this.state.banks.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												label="Número de cuenta"
												type="number"
												color="white"
												value={ transfer?.account_number }
												name="account_number" 
												placeholder="Número de cuenta"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.TRANSFER) } />
											<Input
												label="Titular"
												color="white"
												value={ transfer?.account_name }
												name="account_name" 
												placeholder="Titular"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.TRANSFER) } />
											<div className="container-document">
												<Select
													label="RIF / Cédula"
													name="document_type_id"
													onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.TRANSFER) }
													value={ transfer?.document_type_id }
													options={ this.state.document_types.map((i: any) => {
														return {
															value: i.id,
															label: i.name
														}
													}) } />
												<Input
													label="-"
													type="number"
													color="white"
													value={ transfer?.document }
													name="document" 
													placeholder="Documento"
													onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.TRANSFER) } />
											</div>
										</React.Fragment>
									)
								}

								{
									zelle !== null && this.state.selected == Constants.PAYMENT_METHODS.ZELLE && (
										<React.Fragment>
											<Input
												label="Correo"
												color="white"
												value={ zelle?.email }
												name="email" 
												placeholder="Correo"
												onChange={ (e: any) => this.change(e,Constants.PAYMENT_METHODS.ZELLE) } />
										</React.Fragment>
									)
								}
							</div>
							<div className="text-center">
								<button className="btn btn-save" onClick={ () => this.submit() }>
									Guardar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(BankAccounts);